var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurchasing = function SvgPurchasing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 48.08a5.2 5.2 0 0 0-1-.08 7 7 0 0 0-5 11.92A6.9 6.9 0 0 0 52 62a7 7 0 0 0 1-13.92M52 58a3 3 0 0 1-2.87-2.13A3.1 3.1 0 0 1 49 55a3 3 0 0 1 3-3 3.1 3.1 0 0 1 .87.13A3 3 0 0 1 52 58M32 48.08a5.2 5.2 0 0 0-1-.08 7 7 0 0 0-5 11.92A6.9 6.9 0 0 0 31 62a7 7 0 0 0 1-13.92M31 58a3 3 0 0 1-2.87-2.13A3.1 3.1 0 0 1 28 55a3 3 0 0 1 3-3 3.1 3.1 0 0 1 .87.13A3 3 0 0 1 31 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 45v2a2 2 0 0 1-2 2h-.3a8.92 8.92 0 0 0-5.41-2.9A7.4 7.4 0 0 0 52 46a9 9 0 0 0-6.7 3h-7.6a8.92 8.92 0 0 0-5.41-2.9A7.4 7.4 0 0 0 31 46a9 9 0 0 0-6.68 3A6 6 0 0 1 19 44.18l-6.68-33.57a2 2 0 0 0-2-1.61H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.08A6 6 0 0 1 18 7.82l6.72 33.57a2 2 0 0 0 2 1.61H59a2 2 0 0 1 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 21v20H29V21a2 2 0 0 1 2-2h6v15.83l6-6 6 6V19h6a2 2 0 0 1 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 30-4-4-4 4V19h8z"
  }))));
};
export default SvgPurchasing;